// extracted by mini-css-extract-plugin
export default {"rating":"rating_rating__lEUyL","star":"rating_star__rpLEk","star_o":"rating_star_o__4xO3Q"};